import { render, staticRenderFns } from "./SupplierOrdersModal.vue?vue&type=template&id=319d18e3&"
import script from "./SupplierOrdersModal.vue?vue&type=script&lang=js&"
export * from "./SupplierOrdersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports